
            const data = {"name":"next","data":{"viewBox":"0 0 60 60","data":"<path pid=\"0\" d=\"M30 1l-5.27 5.27 20 20H1v7.54h43.69l-20 20L30 59l29-29z\" _fill=\"#171614\"/>","originalColors":[{"type":"fill","color":"#171614"}],"stopColors":[]}}
        
                module.exports = data
                